var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoffee = function SvgCoffee(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coffee_svg__a)",
    d: "M51 159v5.989C51 178.25 86.37 189 130 189s79-10.75 79-24.011V159z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coffee_svg__b)",
    d: "M130 182c48.049 0 87-10.297 87-23s-38.951-23-87-23-87 10.297-87 23 38.951 23 87 23"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coffee_svg__c)",
    d: "M202.5 138H155v-8.056h47.5a16.948 16.948 0 0 0 0-33.888V88c13.507 0 24.5 11.215 24.5 25s-10.989 25-24.5 25"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coffee_svg__d)",
    d: "M57.275 81a3.29 3.29 0 0 0-3.273 3.416c1.586 45.913 35.005 82.584 76 82.584s74.412-36.671 76-82.584a3.28 3.28 0 0 0-.912-2.402A3.3 3.3 0 0 0 202.729 81z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "coffee_svg__a",
    x1: 130,
    x2: 130,
    y1: 188.67,
    y2: 150.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#027CB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101,
    stopColor: "#077EB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228,
    stopColor: "#1686B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369,
    stopColor: "#3094C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "#54A6CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#81BED9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#B8DAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coffee_svg__b",
    x1: 130,
    x2: 130,
    y1: 181.494,
    y2: 123.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#027CB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101,
    stopColor: "#077EB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228,
    stopColor: "#1686B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369,
    stopColor: "#3094C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "#54A6CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#81BED9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#B8DAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coffee_svg__c",
    x1: 191,
    x2: 191,
    y1: 138,
    y2: 88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#208BBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    stopColor: "#2F93C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.393,
    stopColor: "#49A1C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#6CB3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    stopColor: "#9ACBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#D1E7F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coffee_svg__d",
    x1: 130.002,
    x2: 130.002,
    y1: 166.054,
    y2: 78.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })))));
};
export default SvgCoffee;